/**
 * Base API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ImageConfigEntry { 
    type?: ImageConfigEntry.TypeEnum;
    element?: ImageConfigEntry.ElementEnum;
    sizeType?: ImageConfigEntry.SizeTypeEnum;
    languages?: Array<string>;
}
export namespace ImageConfigEntry {
    export type TypeEnum = 'START_PAGE_IMAGE' | 'APP_LOGO';
    export const TypeEnum = {
        START_PAGE_IMAGE: 'START_PAGE_IMAGE' as TypeEnum,
        APP_LOGO: 'APP_LOGO' as TypeEnum
    };
    export type ElementEnum = 'START_PAGE_IMAGE_DE_DEFAULT' | 'START_PAGE_IMAGE_FR_DEFAULT' | 'START_PAGE_IMAGE_AG' | 'START_PAGE_IMAGE_BE' | 'APP_LOGO_DEFAULT' | 'APP_LOGO_BE' | 'APP_LOGO_BS';
    export const ElementEnum = {
        START_PAGE_IMAGE_DE_DEFAULT: 'START_PAGE_IMAGE_DE_DEFAULT' as ElementEnum,
        START_PAGE_IMAGE_FR_DEFAULT: 'START_PAGE_IMAGE_FR_DEFAULT' as ElementEnum,
        START_PAGE_IMAGE_AG: 'START_PAGE_IMAGE_AG' as ElementEnum,
        START_PAGE_IMAGE_BE: 'START_PAGE_IMAGE_BE' as ElementEnum,
        APP_LOGO_DEFAULT: 'APP_LOGO_DEFAULT' as ElementEnum,
        APP_LOGO_BE: 'APP_LOGO_BE' as ElementEnum,
        APP_LOGO_BS: 'APP_LOGO_BS' as ElementEnum
    };
    export type SizeTypeEnum = 'SMALL' | 'DEFAULT' | 'LARGE';
    export const SizeTypeEnum = {
        SMALL: 'SMALL' as SizeTypeEnum,
        DEFAULT: 'DEFAULT' as SizeTypeEnum,
        LARGE: 'LARGE' as SizeTypeEnum
    };
}


